import { render, staticRenderFns } from "./selectTab1.vue?vue&type=template&id=5c0a7457&scoped=true"
import script from "./selectTab1.vue?vue&type=script&lang=js"
export * from "./selectTab1.vue?vue&type=script&lang=js"
import style0 from "./selectTab1.vue?vue&type=style&index=0&id=5c0a7457&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0a7457",
  null
  
)

export default component.exports